import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import useBreakpoints from '#client/hooks/useBreakpoints';
import useUnitAccount from '#client/hooks/useUnitAccount';
import { getLast4digits } from '#client/utils/text';

import { WrapperStyled } from './DepositTo.styles';

const DepositTo = ({ title = 'Deposit to' }) => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();
  const { unitAccount } = useUnitAccount();
  const { name = '', accountNumber = '' } = unitAccount || {};

  return (
    <WrapperStyled>
      <Text
        color="primary"
        size={isDesktop ? 'lg' : 'md'}
      >
        {title}
      </Text>
      <Stack
        gap="8px"
        textAlign="right"
      >
        <Text
          color="primary"
          size="md"
          weight="medium"
        >
          {name}
        </Text>
        <Text
          color="primary"
          size="md"
          weight="medium"
        >{`Business Checking ${getLast4digits(accountNumber)}`}</Text>
      </Stack>
    </WrapperStyled>
  );
};

DepositTo.propTypes = {
  title: PropTypes.string
};

export default DepositTo;
